const prefix = 'SETUP_FILE_EXPORT';

export const SELECT_OBJECTTYPE = `${prefix}_SELECT_OBJECTTYPE`;
export const SET_HISTORY = `${prefix}_SET_HISTORY`;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/flow/actionTypes.js